// Industry options with full names and short names for display
export const INDUSTRY_OPTIONS = [
  {
    "id": "advertising_marketing",
    "name": "Advertising & Marketing",
    "shortName": "Ad/Marketing"
  },
  {
    "id": "aerospace_defense",
    "name": "Aerospace & Defense",
    "shortName": "Aero/Defense"
  },
  {
    "id": "agriculture",
    "name": "Agriculture",
    "shortName": "Agriculture"
  },
  {
    "id": "ai_machine_learning",
    "name": "AI & Machine Learning",
    "shortName": "AI/ML"
  },
  {
    "id": "architecture_planning",
    "name": "Architecture & Planning",
    "shortName": "Architecture"
  },
  {
    "id": "arts_culture",
    "name": "Arts & Culture",
    "shortName": "Arts/Culture"
  },
  {
    "id": "automotive",
    "name": "Automotive",
    "shortName": "Automotive"
  },
  {
    "id": "biotechnology",
    "name": "Biotechnology",
    "shortName": "BioTech"
  },
  {
    "id": "blockchain_cryptocurrency",
    "name": "Blockchain & Cryptocurrency",
    "shortName": "Blockchain"
  },
  {
    "id": "chemicals",
    "name": "Chemicals",
    "shortName": "Chemicals"
  },
  {
    "id": "construction",
    "name": "Construction",
    "shortName": "Construction"
  },
  {
    "id": "consulting_management_strategy",
    "name": "Consulting (Management & Strategy)",
    "shortName": "Consulting"
  },
  {
    "id": "consumer_electronics",
    "name": "Consumer Electronics",
    "shortName": "Electronics"
  },
  {
    "id": "consumer_goods_cpg_fmcg",
    "name": "Consumer Goods (CPG/FMCG)",
    "shortName": "CPG/FMCG"
  },
  {
    "id": "design_graphic_ux_ui_industrial",
    "name": "Design (Graphic, UX/UI, Industrial)",
    "shortName": "Design"
  },
  {
    "id": "ecommerce_online_retail",
    "name": "E-commerce & Online Retail",
    "shortName": "E-commerce"
  },
  {
    "id": "education_edtech_k12_higher_ed_training",
    "name": "Education (EdTech, K-12, Higher Ed, Training)",
    "shortName": "Education"
  },
  {
    "id": "energy_oil_gas_renewables_utilities",
    "name": "Energy (Oil & Gas, Renewables, Utilities)",
    "shortName": "Energy"
  },
  {
    "id": "engineering_civil_mechanical_electrical",
    "name": "Engineering (Civil, Mechanical, Electrical, etc.)",
    "shortName": "Engineering"
  },
  {
    "id": "entertainment_film_music_gaming_media",
    "name": "Entertainment (Film, Music, Gaming, Media)",
    "shortName": "Entertainment"
  },
  {
    "id": "environmental_services",
    "name": "Environmental Services",
    "shortName": "Environment"
  },
  {
    "id": "events_services",
    "name": "Events Services",
    "shortName": "Events"
  },
  {
    "id": "fashion_apparel",
    "name": "Fashion & Apparel",
    "shortName": "Fashion"
  },
  {
    "id": "financial_services_banking_fintech_insurance_investment",
    "name": "Financial Services (Banking, Fintech, Insurance, Investment)",
    "shortName": "Finance"
  },
  {
    "id": "food_beverage",
    "name": "Food & Beverage",
    "shortName": "Food/Bev"
  },
  {
    "id": "government_public_administration",
    "name": "Government & Public Administration",
    "shortName": "Government"
  },
  {
    "id": "healthcare_hospitals_pharma_medical_devices_healthtech",
    "name": "Healthcare (Hospitals, Pharma, Medical Devices, HealthTech)",
    "shortName": "Healthcare"
  },
  {
    "id": "hospitality_hotels_restaurants_tourism",
    "name": "Hospitality (Hotels, Restaurants, Tourism)",
    "shortName": "Hospitality"
  },
  {
    "id": "human_resources_staffing",
    "name": "Human Resources & Staffing",
    "shortName": "HR/Staffing"
  },
  {
    "id": "it_services_support",
    "name": "Information Technology (IT) Services & Support",
    "shortName": "IT Services"
  },
  {
    "id": "internet_web_services",
    "name": "Internet & Web Services",
    "shortName": "Web Services"
  },
  {
    "id": "legal_services",
    "name": "Legal Services",
    "shortName": "Legal"
  },
  {
    "id": "logistics_supply_chain",
    "name": "Logistics & Supply Chain",
    "shortName": "Logistics"
  },
  {
    "id": "manufacturing",
    "name": "Manufacturing",
    "shortName": "Manufacturing"
  },
  {
    "id": "media_publishing",
    "name": "Media & Publishing",
    "shortName": "Media/Publish"
  },
  {
    "id": "mining_metals",
    "name": "Mining & Metals",
    "shortName": "Mining"
  },
  {
    "id": "non_profit_ngos",
    "name": "Non-profit & NGOs",
    "shortName": "Non-profit"
  },
  {
    "id": "pharmaceuticals",
    "name": "Pharmaceuticals",
    "shortName": "Pharma"
  },
  {
    "id": "professional_services_accounting_legal",
    "name": "Professional Services (e.g., Accounting, Legal)",
    "shortName": "Prof. Services"
  },
  {
    "id": "real_estate_property",
    "name": "Real Estate & Property",
    "shortName": "Real Estate"
  },
  {
    "id": "research_development",
    "name": "Research & Development",
    "shortName": "R&D"
  },
  {
    "id": "retail_brick_mortar",
    "name": "Retail (Brick & Mortar)",
    "shortName": "Retail (B&M)"
  },
  {
    "id": "saas_software_as_a_service",
    "name": "SaaS (Software as a Service)",
    "shortName": "SaaS"
  },
  {
    "id": "security_cybersecurity_physical",
    "name": "Security (Cybersecurity, Physical Security)",
    "shortName": "Security"
  },
  {
    "id": "semiconductors",
    "name": "Semiconductors",
    "shortName": "Semiconductor"
  },
  {
    "id": "software_development_excluding_saas",
    "name": "Software Development (excluding SaaS if distinct)",
    "shortName": "Software Dev"
  },
  {
    "id": "sports_recreation",
    "name": "Sports & Recreation",
    "shortName": "Sports/Rec"
  },
  {
    "id": "telecommunications",
    "name": "Telecommunications",
    "shortName": "Telecom"
  },
  {
    "id": "transportation_logistics",
    "name": "Transportation & Logistics",
    "shortName": "Transport"
  },
  {
    "id": "venture_capital_private_equity",
    "name": "Venture Capital & Private Equity",
    "shortName": "VC/PE"
  },
  {
    "id": "other",
    "name": "Other",
    "shortName": "Other"
  }
];

// Company size options with full names and short names for display
export const COMPANY_SIZE_OPTIONS = [
  {
    "id": "size_1_10",
    "name": "1-10",
    "shortName": "1-10"
  },
  {
    "id": "size_11_50",
    "name": "11-50",
    "shortName": "11-50"
  },
  {
    "id": "size_51_200",
    "name": "51-200",
    "shortName": "51-200"
  },
  {
    "id": "size_201_500",
    "name": "201-500",
    "shortName": "201-500"
  },
  {
    "id": "size_501_1000",
    "name": "501-1,000",
    "shortName": "501-1k"
  },
  {
    "id": "size_1001_5000",
    "name": "1,001-5,000",
    "shortName": "1k-5k"
  },
  {
    "id": "size_5001_10000",
    "name": "5,001-10,000",
    "shortName": "5k-10k"
  },
  {
    "id": "size_10000_plus",
    "name": "10,000+",
    "shortName": "10k+"
  }
];

// Helper function to get industry object by ID
export const getIndustryById = (id) => {
  return INDUSTRY_OPTIONS.find(industry => industry.id === id) || null;
};

// Helper function to get industry object by name
export const getIndustryByName = (name) => {
  return INDUSTRY_OPTIONS.find(industry => industry.name === name) || null;
};

// Helper function to get short name by industry name
export const getShortNameByIndustryName = (name) => {
  const industry = INDUSTRY_OPTIONS.find(industry => industry.name === name);
  return industry ? industry.shortName : name;
};

// Helper function to get company size object by ID
export const getCompanySizeById = (id) => {
  return COMPANY_SIZE_OPTIONS.find(size => size.id === id) || null;
};

// Helper function to get company size object by name
export const getCompanySizeByName = (name) => {
  return COMPANY_SIZE_OPTIONS.find(size => size.name === name) || null;
};

// Helper function to get short name by company size name
export const getShortNameByCompanySizeName = (name) => {
  const size = COMPANY_SIZE_OPTIONS.find(size => size.name === name);
  return size ? size.shortName : name;
}; 